import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// Mask.tsx
import React from "react";

// styles.tsx
var defaultStyles = {
  maskWrapper: function maskWrapper() {
    return {
      opacity: 0.7,
      left: 0,
      top: 0,
      position: "fixed",
      zIndex: 99999,
      pointerEvents: "none",
      color: "#000"
    };
  },
  svgWrapper: function svgWrapper(_ref) {
    var windowWidth = _ref.windowWidth,
      windowHeight = _ref.windowHeight,
      wpt = _ref.wpt,
      wpl = _ref.wpl;
    return {
      width: windowWidth,
      height: windowHeight,
      left: Number(wpl),
      top: Number(wpt),
      position: "fixed"
    };
  },
  maskArea: function maskArea(_ref2) {
    var x = _ref2.x,
      y = _ref2.y,
      width = _ref2.width,
      height = _ref2.height;
    return {
      x: x,
      y: y,
      width: width,
      height: height,
      fill: "black",
      rx: 0
    };
  },
  maskRect: function maskRect(_ref3) {
    var windowWidth = _ref3.windowWidth,
      windowHeight = _ref3.windowHeight,
      maskID = _ref3.maskID;
    return {
      x: 0,
      y: 0,
      width: windowWidth,
      height: windowHeight,
      fill: "currentColor",
      mask: "url(#".concat(maskID, ")")
    };
  },
  clickArea: function clickArea(_ref4) {
    var windowWidth = _ref4.windowWidth,
      windowHeight = _ref4.windowHeight,
      clipID = _ref4.clipID;
    return {
      x: 0,
      y: 0,
      width: windowWidth,
      height: windowHeight,
      fill: "currentcolor",
      pointerEvents: "auto",
      clipPath: "url(#".concat(clipID, ")")
    };
  },
  highlightedArea: function highlightedArea(_ref5) {
    var x = _ref5.x,
      y = _ref5.y,
      width = _ref5.width,
      height = _ref5.height;
    return {
      x: x,
      y: y,
      width: width,
      height: height,
      pointerEvents: "auto",
      fill: "transparent",
      display: "none"
    };
  }
};
function stylesMatcher(styles) {
  return function (key, state) {
    var base = defaultStyles[key](state);
    var custom = styles[key];
    return custom ? custom(base, state) : base;
  };
}

// Mask.tsx
import { safe, getWindow, getPadding } from "@reactour/utils";
var Mask = function Mask(_ref6) {
  var _ref6$padding = _ref6.padding,
    padding = _ref6$padding === void 0 ? 10 : _ref6$padding,
    _ref6$wrapperPadding = _ref6.wrapperPadding,
    wrapperPadding = _ref6$wrapperPadding === void 0 ? 0 : _ref6$wrapperPadding,
    onClick = _ref6.onClick,
    onClickHighlighted = _ref6.onClickHighlighted,
    _ref6$styles = _ref6.styles,
    styles = _ref6$styles === void 0 ? {} : _ref6$styles,
    sizes = _ref6.sizes,
    className = _ref6.className,
    highlightedAreaClassName = _ref6.highlightedAreaClassName,
    maskId = _ref6.maskId,
    clipId = _ref6.clipId;
  var maskID = maskId || uniqueId("mask__");
  var clipID = clipId || uniqueId("clip__");
  var getStyles = stylesMatcher(styles);
  var _getPadding = getPadding(padding),
    _getPadding2 = _slicedToArray(_getPadding, 4),
    pt = _getPadding2[0],
    pr = _getPadding2[1],
    pb = _getPadding2[2],
    pl = _getPadding2[3];
  var _getPadding3 = getPadding(wrapperPadding),
    _getPadding4 = _slicedToArray(_getPadding3, 4),
    wpt = _getPadding4[0],
    wpr = _getPadding4[1],
    wpb = _getPadding4[2],
    wpl = _getPadding4[3];
  var _getWindow = getWindow(),
    w = _getWindow.w,
    h = _getWindow.h;
  var width = safe((sizes == null ? void 0 : sizes.width) + pl + pr);
  var height = safe((sizes == null ? void 0 : sizes.height) + pt + pb);
  var top = safe((sizes == null ? void 0 : sizes.top) - pt - wpt);
  var left = safe((sizes == null ? void 0 : sizes.left) - pl - wpl);
  var windowWidth = w - wpl - wpr;
  var windowHeight = h - wpt - wpb;
  var maskAreaStyles = getStyles("maskArea", {
    x: left,
    y: top,
    width: width,
    height: height
  });
  var highlightedAreaStyles = getStyles("highlightedArea", {
    x: left,
    y: top,
    width: width,
    height: height
  });
  return /* @__PURE__ */React.createElement("div", {
    style: getStyles("maskWrapper", {}),
    onClick: onClick,
    className: className
  }, /* @__PURE__ */React.createElement("svg", {
    width: windowWidth,
    height: windowHeight,
    xmlns: "http://www.w3.org/2000/svg",
    style: getStyles("svgWrapper", {
      windowWidth: windowWidth,
      windowHeight: windowHeight,
      wpt: wpt,
      wpl: wpl
    })
  }, /* @__PURE__ */React.createElement("defs", null, /* @__PURE__ */React.createElement("mask", {
    id: maskID
  }, /* @__PURE__ */React.createElement("rect", {
    x: 0,
    y: 0,
    width: windowWidth,
    height: windowHeight,
    fill: "white"
  }), /* @__PURE__ */React.createElement("rect", {
    style: maskAreaStyles,
    rx: maskAreaStyles.rx ? 1 : void 0
  })), /* @__PURE__ */React.createElement("clipPath", {
    id: clipID
  }, /* @__PURE__ */React.createElement("polygon", {
    points: "0 0, 0 ".concat(windowHeight, ", ").concat(left, " ").concat(windowHeight, ", ").concat(left, " ").concat(top, ", ").concat(left + width, " ").concat(top, ", ").concat(left + width, " ").concat(top + height, ", ").concat(left, " ").concat(top + height, ", ").concat(left, " ").concat(windowHeight, ", ").concat(windowWidth, " ").concat(windowHeight, ", ").concat(windowWidth, " 0")
  }))), /* @__PURE__ */React.createElement("rect", {
    style: getStyles("maskRect", {
      windowWidth: windowWidth,
      windowHeight: windowHeight,
      maskID: maskID
    })
  }), /* @__PURE__ */React.createElement("rect", {
    style: getStyles("clickArea", {
      windowWidth: windowWidth,
      windowHeight: windowHeight,
      top: top,
      left: left,
      width: width,
      height: height,
      clipID: clipID
    })
  }), /* @__PURE__ */React.createElement("rect", {
    style: highlightedAreaStyles,
    className: highlightedAreaClassName,
    onClick: onClickHighlighted,
    rx: highlightedAreaStyles.rx ? 1 : void 0
  })));
};
var Mask_default = Mask;
function uniqueId(prefix) {
  return prefix + Math.random().toString(36).substring(2, 16);
}

// index.tsx
var mask_default = Mask_default;
export { Mask_default as Mask, mask_default as default };